import { adminFetch } from "./base";
import type { FeatureFlag } from "@/lib/feature-flags/types";

interface UpdateFlagPayload {
  enabled?: boolean;
  roles?: string[];
  environment?: "production" | "staging" | "dev" | "all";
  percentage?: number;
  reason: string;
}

export async function updateFeatureFlag(
  key: string,
  payload: UpdateFlagPayload,
): Promise<{ flag: FeatureFlag }> {
  return adminFetch(`/api/admin/flags/${encodeURIComponent(key)}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export async function fetchAllFlags(): Promise<{ flags: FeatureFlag[] }> {
  return adminFetch("/api/flags");
}
